/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export enum ViewBy {
  DAY = 'day',
  MONTH = 'month',
}

export enum ChartType {
  LINE = 'line',
  BAR = 'bar',
}

export enum ProductType {
  Deployments = 'deployments',
  Projects = 'projects',
}

export enum ServerlessExtras {
  Support = 'serverless_support',
  Addons = 'serverless_addons',
}

export enum Solution {
  Security = 'security',
  Observability = 'observability',
  Search = 'elasticsearch',
}

export enum GroupBy {
  Product = 'product',
  Instance = 'instance',
}

export type BucketingStrategy = 'daily' | 'monthly'

export interface ChartItem {
  timestamp: number
  values: Array<{
    id: string
    name: string
    type: string
    value: number
  }>
}
